{
    "translation": {
        "common": {
            "save": "Save",
            "abort": "Abort",
            "back": "Back",
            "close": "Close",
            "new": "New",
            "nothingSelected": "Nothing selected",
            "project": "Project",
            "delete": "Delete",
            "deleted": "Deleted",
            "active": "Active",
            "yes": "Yes",
            "no": "No",
            "youSure": "Are you sure?",
            "noReturn": "This action cannot be undone.",
            "search": "Search",
            "homepage": "Homepage",
            "trackings": "Trackings",
            "user": "Users",
            "projects": "Projects",
            "reports": "Reports",
            "admin": "Admin",
            "holidays": "Holidays",
            "globalSettings": "Global settings",
            "businesses": "Businesses",
            "workingTimeModel": "Working time models",
            "about": "About",
            "help": "Help",
            "settings": "Settings",
            "signOut": "Sign out",
            "edit": "Edit",
            "from": "From",
            "to": "To",
            "name": "Name",
            "description": "Description",
            "start": "Start",
            "stop": "Stop",
            "noTrackingStarted": "No Tracking started",
            "trackingWithoutTime": "Started Tracking without time",
            "noProject": "No Project",
            "filter": "Filter",
            "toFilter": "Filter",
            "view": "View",
            "now": "Now",
            "durationSum": "Sum: {{value, duration}}",
            "today": "Today",
            "login": "Login",
            "noTrackings": "No trackings",
            "reload": "reload",
            "ui": {
                "systemPreferenceMode": "System",
                "darkMode": "Dark mode",
                "lightMode": "Light mode"
            },
            "timeOnly": {
                "duration": "{{value, duration}}",
                "short": "{{value, datetime(hour: numeric; minute: numeric)}}"
            },
            "dateOnly": {
                "short": "{{value, datetime(year: numeric; month: numeric; day: numeric)}}",
                "yearMonth": "{{value, datetime(year: numeric; month: numeric)}}",
                "yearOnly": "{{value, datetime(year: numeric)}}"
            },
            "actions": "Actions",
            "hours": "Hours",
            "allProjects": "All Projects",
            "statistics": "Statistics",
            "noWorkingTimeModelAssigned": "No working time model assigned"
        },
        "landingPage": {
            "welcome": "Welcome to Time Tracking!",
            "pleaseAuthenticate": "Please authenticate to continue."
        },
        "todaysTrackings": {
            "title": "Today's Trackings"
        },
        "closedTrackings": {
            "title": "Manual changes needed"
        },
        "bookedTime": {
            "title": "Booked Time",
            "day": "Day",
            "week": "Week",
            "month": "Month",
            "year": "Year"
        },
        "editTrackings": {
            "day": "Day",
            "start": "Start",
            "end": "End",
            "typeOfTracking": "Type of Tracking",
            "publicDescription": "Public description",
            "internalDescription": "Internal description",
            "fromBeforeTo": "Must be before the end time.",
            "askYourAdmin": "Please contact an administrator",
            "trackingCreateAtStartOfWTM": "The was created at the start of the day."
        },
        "trackings": {
            "filters": {
                "fromTo": "{{from, datetime(year: numeric; month: numeric; day: numeric)}} - {{to, datetime(year: numeric; month: numeric; day: numeric)}}",
                "fromUntilToday": "{{from, datetime(year: numeric; month: numeric; day: numeric)}} - Today",
                "fromInFuture": "From {{from, datetime(year: numeric; month: numeric; day: numeric)}}",
                "todayUntilTo": "Today - {{to, datetime(year: numeric; month: numeric; day: numeric)}}",
                "toInPast": "Until {{to, datetime(year: numeric; month: numeric; day: numeric)}}"
            },
            "breakBetweenTrackings": "{{value, duration}} Pause"
        },
        "projects": {
            "urlEdit": "Admin / Projects / Edit",
            "urlCreate": "Admin / Projects / New",
            "urlIndex": "Admin / Projects",
            "edit": "Edit Project",
            "create": "Create Project",
            "color": "Color",
            "name": "Project name",
            "description": "Description",
            "startDate": "Start date",
            "endDate": "End date",
            "valid": "Valid",
            "externalReference": "External reference",
            "colorSelection": "Color selection",
            "trackingType": "Tracking Type",
            "deleted": "Deleted",
            "startWithProject": "Start with Project",
            "switchProject": "Switch Project",
            "users": "Users",
            "selectProject": "Select Project"
        },
        "snackbar": {
            "successCreateBusiness": "Business successfully created.",
            "successCreateProject": "Project successfully created.",
            "successCreateUser": "User successfully created.",
            "successCreateWorkingTimeModel": "Working Time Model successfully created",
            "successDuplicateWorkingTimeModel": "Create working time model form was prefilled.",
            "successEditProject": "Project successfully adjusted.",
            "successEditUser": "User successfully adjusted",
            "successEditWorkingTimeModel": "Working Time Model successfully adjusted.",
            "successDeleteWorkingTimeModel": "Working Time Model successfully deleted.",
            "successDeleteProject": "Project successfully deleted.",
            "successDeleteBusiness": "Business successfully deleted.",
            "successDeleteUser": "User successfully deleted.",
            "successAbortTracking": "Tracking successfully aborted.",
            "successStartTracking": "Tracking successfully started.",
            "successSwitchTracking": "Tracking successfully switched.",
            "successStopTracking": "Tracking successfully stopped.",
            "successEditDescriptionTracking": "Tracking description successfully adjusted.",
            "successEditTrackings": "Trackings successfully adjusted.",
            "successEditBusiness": "Business successfully edited.",
            "successSetGlobalSettings": "Global settings successfully set.",
            "successGenerateReport": "Report successfully created.",
            "successDownloadReport": "Report successfully downloaded.",
            "successUpdatePassword": "Password successfully changed.",
            "successCopyReportData": "Report successfully copied.",
            "failedCreateBusiness": "Business could not be created.",
            "failedCreateProject": "Project could not be created.",
            "failedCreateUser": "User could not be created.",
            "failedCreateWorkingTimeModel": "Working time model could not be created",
            "failedEditProject": "Project could not be adjusted.",
            "failedEditUser": "User could not be adjusted.",
            "failedEditBusiness": "Business could not be edited.",
            "failedEditWorkingTimeModel": "Working Time Model could not be adjusted.",
            "failedDeleteWorkingTimeModel": "Working Time Model could not be deleted.",
            "failedDeleteProject": "Project could not be deleted.",
            "failedDeleteBusiness": "Business could not be deleted.",
            "failedAbortTracking": "Tracking could not be aborted.",
            "failedStartTracking": "Tracking could not be started.",
            "failedSwitchTracking": "Tracking could not be switched.",
            "failedStopTracking": "Tracking could not be stopped.",
            "failedEditDescriptionTracking": "Tracking description could not be adjusted.",
            "failedEditTrackings": "Trackings could not be updated.",
            "failedSetGlobalSettings": "Global settings could not be set.",
            "failedGenerateReport": "Report couldn't be created.",
            "failedDownloadReport": "Report couldn't be downloaded.",
            "failedUpdatePassword": "Password couldn't be changed.",
            "failedSetUserSettings": "The user settings couldn't be set.",
            "failedValidation": "There are validation errors."
        },
        "user": {
            "initials": "Initials",
            "firstName": "First name",
            "lastName": "Last name",
            "email": "E-Mail",
            "emailConfirmed": "E-Mail confirmed",
            "userName": "Username",
            "role": "Role",
            "currentPassword": "Current password",
            "password": "Password",
            "passwordRepeat": "Repeat password",
            "urlUser": "Admin / Users",
            "urlEdit": "Admin / Users / Edit",
            "urlNew": "Admin / Users / New",
            "edit": "Edit User",
            "create": "Create User",
            "businessLocations": "Business Locations"
        },
        "validation": {
            "workingTimeModelIdRequired": "Working time model must not be empty.",
            "workingTimeModelValidFromRequired": "From date must not be empty.",
            "workingTimeModelValidUntilRequired": "To date must not be empty.",
            "workingTimeModelOverlapFrom": "From overlaps with another working time model.",
            "workingTimeModelOverlapUntil": "To overlaps with another working time model.",
            "passwordsMustMatch": "Passwords must match.",
            "workTimeStartAtRequired": "If the starting point is set, the working time must also be set.",
            "workTimeDurationRequired": "If the working time is set, the starting point must also be set.",
            "trackingTypeRequired": "Tracking Type needs to be selected.",
            "selectionRequired": "Something must be selected.",
            "required": "Cannot be empty.",
            "endBeforeStart": "End cannot be before the start.",
            "overlappingEntries": "Overlaps with another entry.",
            "startOutOfBounds": "Start is outside the allowed time range.",
            "endOutOfBounds": "End is outside the allowed time range.",
            "emptyArrayExpected": "Empty array expected.",
            "nonNullValueExpected": "Non null value expected.",
            "timeSection": "Time section of date needs to be 0.",
            "date_must_be_after_or_equal": "Must be after or equal to {date}.",
            "date_must_be_before_or_equal": "Must be before or equal to {date}."
        },
        "dateTime": {
            "dayOfWeek": "Weekday",
            "start": "Starting Point",
            "duration": "Working Time",
            "noDays": "No Days",
            "monday": "Monday",
            "tuesday": "Tuesday",
            "wednesday": "Wednesday",
            "thursday": "Thursday",
            "friday": "Friday",
            "saturday": "Saturday",
            "sunday": "Sunday"
        },
        "workingTimeModel": {
            "urlEdit": "Admin / Working Time Models / Edit",
            "urlCreate": "Admin / Working Time Models / Create",
            "urlIndex": "Admin / Working Time Models",
            "edit": "Edit Working Time Model",
            "create": "Create Working Time Model",
            "noTrackingBefore": "No Trackings before",
            "noTrackingAfter": "No Trackings after",
            "pauseAfter": "Pause at least after",
            "pauseDuration": "Minimum Pause Duration",
            "maximumWorkTimePerDay": "Maximum Working Time per Day",
            "allowOverlappingTrackings": "Allow Overlapping Trackings",
            "assignableFrom": "Assignable from",
            "assignableUntil": "Assignable until",
            "assignableFromAfterUntil": "Assignable from can't be after assignable until.",
            "duplicate": "Duplicate",
            "userWorkingTimeModelsAutoEnded": "The end of the assigned working time model was set for the following users:"
        },
        "holidays": {
            "urlIndex": "Admin / Holidays"
        },
        "settings": {
            "languages": {
                "german": "German",
                "english": "English"
            },
            "pageTitle": "Settings",
            "language": "Language",
            "commonTab": "Common",
            "passwordTab": "Password",
            "timeProgressToDate": "Calculate Booked Time until today.",
            "timeProgressToDateHelper": "The time that should be booked will be calculated until today and not until the end of the selected timespan.",
            "useCalendarForTrackings": "Use a calendar instead of a list.",
            "useCalendarForTrackingsHelper": "Use a calender for the trackings overview, instead of a list."
        },
        "business": {
            "name": "Business name",
            "urlEdit": "Admin / Business / Edit",
            "urlNew": "Admin / Business / New",
            "urlIndex": "Admin / Business",
            "edit": "Edit Business",
            "create": "Create Business",
            "business": "Business",
            "location": "Locations",
            "locationName": "Location name",
            "noLocations": "No Locations",
            "addLocation": "Add Location",
            "locationCount": "Location count"
        },
        "globalSettings": {
            "url": "Admin / Global settings",
            "title": "Global settings",
            "primaryColorLight": "Primary color light scheme",
            "secondaryColorLight": "Secondary color light scheme",
            "primaryColorDark": "Primary color dark scheme",
            "secondaryColorDark": "Secondary color dark scheme",
            "uploadLogo": "Upload logo"
        },
        "navigationFormBlocker": {
            "areYouSure": "Are you sure you want to leave?",
            "unsavedChangesLost": "Unsaved changes will be lost."
        },
        "statistics": {
            "hoursPerProject": "Hours per Project",
            "hoursInTimespan": "Hours in timespan",
            "compareHoursToWorkingTimeModel": "Compare planned/actual worked hours",
            "noData": "No Data available",
            "workedTimeHours": "{{value}} $t(common.hours) worked",
            "differenceBetweenWorkedTimeAndWTMHoursPositive": "{{value}} $t(common.hours) more than the working time model",
            "differenceBetweenWorkedTimeAndWTMHoursNegative": "{{value}} $t(common.hours) less than the working time model"
        },
        "reports": {
            "reportsTitle": "Reports",
            "reportsUrl": "Admin / Reports",
            "outputFormat": "Output format",
            "csvExportQuoteCharacter": "Quote character used in export",
            "csvExportSeperatorCharacter": "Seperator character used in export",
            "csvExportQuoteCharacterNone": "None",
            "generateReport": "Create report",
            "downloadFile": "Download",
            "trackings": {
                "projects": "Projects",
                "users": "Users",
                "round": "Round time",
                "combineAdjacentTrackings": "Combine adjacent trackings",
                "joinDescriptionCharacter": "Character used for joined descriptions of adjacent trackings",
                "includeDurationColumn": "Include duration in output",
                "includeDescriptionColumn": "Include description in output",
                "projectAndUserIdsCantBothBeEmpty": "Projects and users can't both be empty, atleast one project or one user needs to be selected."
            },
            "table": "Table",
            "raw": "Raw data"
        },
        "notifications": {
            "noNotifications": "No notifications",
            "trackingAborted": "Tracking was aborted",
            "trackingStartEnd": "{{start, datetime(year: numeric; month: numeric; day: numeric; hour: numeric; minute: numeric)}} - {{end, datetime(hour: numeric; minute: numeric)}}"
        },
        "pwa": {
            "offlineReady": "TimeTracking was installed successfully.",
            "offlineReadyExplanation": "The app will startup faster now.",
            "newVersion": "A new TimeTracking version is available. Do you want to use the new version?",
            "newVersionExplanation": "The page must be reloaded for the new version to be used."
        },
        "errorComponent": {
            "title": "There was an error.",
            "subTitle": "Please forward the following information.",
            "reload": "Reload"
        },
        "onboarding": {
            "welcomeLabel": "Welcome",
            "welcomeText": "Click 'Next' to continue.",
            "documentWorkLabel": "Document your work",
            "documentWorkText": "Keep track of all your work and organize it by projects.",
            "stayConcentratedLabel": "Stay concentrated",
            "stayConcentratedText": "Automate time tracking and focus on important tasks.",
            "next": "Next",
            "prev": "Back",
            "finish": "Finish"
        },
        "about": {
            "pageTitle": "About the TimeTracking",
            "backendAssemblyVersions": "The backend is based on the commit {{commit}} and runs with the following parts:",
            "frontendVersion": "The frontend is based on the commit {{commit}} and runs with version {{version}}.",
            "madeWithLove": "Made with ❤️ by us, for us.",
            "versionNumber": "Version number",
            "usedVersions": "Used versions",
            "changelog": "Changelog"
        }
    }
}
